import React from "react";
import { Home, BookOpen, GraduationCap, Hammer, PenTool } from 'lucide-react';
import { Link, useLocation } from "react-router-dom";

const FooterMenuModern = () => {
  const location = useLocation();

  const menuItems = [
    {
      path: "/",
      icon: Home,
      label: "Home",
      exact: true
    },
    {
      path: "/mobile/academy",
      icon: BookOpen,
      label: "Academy"
    },
    {
      path: "/study",
      icon: GraduationCap,
      label: "Study"
    },
    {
      path: "/tools",
      icon: Hammer,
      label: "Tools"
    }
  ];

  const isActive = (item) => {
    if (item.exact) {
      return location.pathname === item.path;
    }
    if (location.pathname.startsWith(item.path)) {
      return true;
    }
    if (location.pathname === '/mobile/login') {
      const intendedPath = location.state?.from || '';
      return intendedPath.startsWith(item.path);
    }
    return false;
  };

  return (
    <div className="mobile-footer-modern">
      <div className="footer-menu-container">
        {menuItems.map((item, index) => {
          const IconComponent = item.icon;
          return (
            <Link
              key={index}
              to={item.path}
              className={`footer-menu-item ${isActive(item) ? 'active' : ''}`}
            >
              <div className="menu-icon">
                <IconComponent size={20} />
              </div>
              <div className="menu-label">
                {item.label}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default FooterMenuModern; 
